<template>
  <!-- cart reset -->
</template>

<script>
import {bus} from '../../bus'
export default {
    data() {
        return {
            countItems: 0
        }
    },
    created() {
      localStorage.removeItem("items")
    },
    methods: {

    },
    mounted() {

    }
}
</script>
